import { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./CheckoutModal.module.css";
import { BundleBuilderConfigInterface, PlaceholderConfigInterface } from "../../Types";
import { hexToHsla } from "../../../../utilities/parsers";
import { CART_CHANGE_ANALYZED } from "../../../constants";
import { openStoreCart } from "../../RenderOnStore/utilities";

type Props_ProductInfoModal = {
    showCheckoutModal: any;
    onClose: () => void;
    bundleConfig: BundleBuilderConfigInterface | PlaceholderConfigInterface;
};

const CheckoutModal = ({ showCheckoutModal, onClose, bundleConfig }: Props_ProductInfoModal) => {
    useEffect(() => {
        if (showCheckoutModal && window.innerWidth <= 840) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [showCheckoutModal]);

    const handleViewCart = () => {
        onClose();
        window.kefi_skip_cart_open = false;
        openStoreCart();
    };

    const isPopupContentEmpty = (html: string): boolean => {
        const text = html.replace(/<[^>]+>/g, "").trim();
        return text === "";
    };

    const isPopupTextEmpty = isPopupContentEmpty(bundleConfig?.popup_text);

    return ReactDOM.createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <button
                    className={styles.closeBtn}
                    onClick={() => {
                        handleViewCart();
                    }}
                >
                    ✖
                </button>

                <div className={styles.mainContainer}>
                    {!isPopupTextEmpty && (
                        <div
                            className={styles.popupText}
                            dangerouslySetInnerHTML={{ __html: bundleConfig?.popup_text }}
                        ></div>
                    )}

                    <div
                        className={styles.buttons}
                        style={{
                            marginTop: isPopupTextEmpty ? "16px" : "0",
                        }}
                    >
                        <button
                            className={styles.singleButton}
                            style={{
                                color:
                                    hexToHsla(bundleConfig?.bundles_design?.add_to_cart_bg_color || "#ffffff")
                                        ?.brightness < 0.5
                                        ? "#ffffff"
                                        : "#000000",
                                border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                                background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                            }}
                            onClick={() => {
                                if (bundleConfig?.popup_redirect_url) {
                                    window.location = bundleConfig?.popup_redirect_url as unknown as Location;
                                } else {
                                    onClose();
                                }
                            }}
                        >
                            {(bundleConfig as BundleBuilderConfigInterface)?.checkout_continue_shopping_cta_text ??
                                "Continue Shopping"}
                        </button>

                        <button
                            className={styles.singleButton}
                            style={{
                                background: "#ffffff",
                                color: "#000000",
                                border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                            }}
                            onClick={handleViewCart}
                        >
                            {(bundleConfig as BundleBuilderConfigInterface)?.checkout_view_cart_cta_text ?? "View Cart"}
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default CheckoutModal;
